import { createEnv } from '@pickleballinc/lib/env';

import { publicEnvSchema, serverEnvSchema, systemEnvSchema } from '@/lib/env-schema';

export const systemEnv = createEnv(systemEnvSchema, {
  DOCKER_BUILD: process.env.DOCKER_BUILD,
  DEBUG_ENV_VAR: process.env.DEBUG_ENV_VAR,
  BUILD_ID: process.env.BUILD_ID,
  NODE_ENV: process.env.NODE_ENV,
  NEXT_RUNTIME: process.env.NEXT_RUNTIME,
});

export const publicEnv = createEnv(publicEnvSchema, {
  NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
  NEXT_PUBLIC_RTE_ENABLED: process.env.NEXT_PUBLIC_RTE_ENABLED,
  NEXT_PUBLIC_IMAGE_UPLOAD_URL: process.env.NEXT_PUBLIC_IMAGE_UPLOAD_URL,
  NEXT_PUBLIC_IMAGE_CDN_URL: process.env.NEXT_PUBLIC_IMAGE_CDN_URL,
  NEXT_PUBLIC_PBRACKETS_CDN_URL: process.env.NEXT_PUBLIC_PBRACKETS_CDN_URL,
  NEXT_PUBLIC_HOME_ROOT_URL: process.env.NEXT_PUBLIC_HOME_ROOT_URL,
  NEXT_PUBLIC_PT_URL: process.env.NEXT_PUBLIC_PT_URL,
  NEXT_PUBLIC_PL_URL: process.env.NEXT_PUBLIC_PL_URL,
  NEXT_PUBLIC_PC_URL: process.env.NEXT_PUBLIC_PC_URL,
  NEXT_PUBLIC_PTL_URL: process.env.NEXT_PUBLIC_PTL_URL,
  NEXT_PUBLIC_APR_URL: process.env.NEXT_PUBLIC_APR_URL,
  NEXT_PUBLIC_SSO_URL: process.env.NEXT_PUBLIC_SSO_URL,
  NEXT_PUBLIC_PBRACKETS_URL: process.env.NEXT_PUBLIC_PBRACKETS_URL,
  NEXT_PUBLIC_BRACKETS_URL: process.env.NEXT_PUBLIC_BRACKETS_URL,
  NEXT_PUBLIC_CONTACT_FORM_URL: process.env.NEXT_PUBLIC_CONTACT_FORM_URL,
  NEXT_PUBLIC_MANAGE_URL: process.env.NEXT_PUBLIC_MANAGE_URL,
  NEXT_PUBLIC_CHECKOUT_URL: process.env.NEXT_PUBLIC_CHECKOUT_URL,
  NEXT_PUBLIC_TOURNAMENT_CHECKOUT_URL: process.env.NEXT_PUBLIC_TOURNAMENT_CHECKOUT_URL,
  NEXT_PUBLIC_PL_CHECKOUT_URL: process.env.NEXT_PUBLIC_PL_CHECKOUT_URL,
  NEXT_PUBLIC_ADBUTLER_URL: process.env.NEXT_PUBLIC_ADBUTLER_URL,
  NEXT_PUBLIC_PICKLEBALLTV_URL: process.env.NEXT_PUBLIC_PICKLEBALLTV_URL,
  NEXT_PUBLIC_GM_URL: process.env.NEXT_PUBLIC_GM_URL,
  NEXT_PUBLIC_TINYMCE_API_KEY: process.env.NEXT_PUBLIC_TINYMCE_API_KEY,
  NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  NEXT_PUBLIC_PL_KEY: process.env.NEXT_PUBLIC_PL_KEY,
  NEXT_PUBLIC_GOOGLE_ANALYTICS: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS,
  NEXT_PUBLIC_RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
});

export const serverEnv = createEnv(serverEnvSchema, {
  API_URL: process.env.API_URL,
  API_URL_V2: process.env.API_URL_V2,
  API_KEY: process.env.API_KEY,
  SSO_HEADLESS_API_KEY: process.env.SSO_HEADLESS_API_KEY,
  AUTH_GATEWAY_URL: process.env.AUTH_GATEWAY_URL,
  AUTH_GATEWAY_KEY: process.env.AUTH_GATEWAY_KEY,
  STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY,
  REVENUECAT_SECRET_KEY: process.env.REVENUECAT_SECRET_KEY,
  REVENUECAT_PROJECT_ID: process.env.REVENUECAT_PROJECT_ID,
  LADDER_LEAGUES_NOTIFICATIONS_SECRET_KEY: process.env.LADDER_LEAGUES_NOTIFICATIONS_SECRET_KEY,
  RECAPTCHA_API_KEY: process.env.RECAPTCHA_API_KEY,
  RECAPTCHA_PROJECT_ID: process.env.RECAPTCHA_PROJECT_ID,
  SENTRY_DEBUG: process.env.SENTRY_DEBUG,
  SENTRY_SAMPLE_RATE: process.env.SENTRY_SAMPLE_RATE,
  SENTRY_TRACES_SAMPLE_RATE: process.env.SENTRY_TRACES_SAMPLE_RATE,
  APR_PASSWORD: process.env.APR_PASSWORD,
  DAILY_STORY_JWT_SECRET: process.env.DAILY_STORY_JWT_SECRET,
});
